<script setup lang="ts">
defineProps<{
  product: SingleProduct
}>()
</script>

<template>
  <article v-if="product.template === 'pluss'" class="bg-(--background) text-(--color)">
    <CrystallizeImage
      :image="product.cover"
      img-class="max-h-72 w-full object-cover"
    />

    <section class="pb-48">
      <UContainer class="my-19 flex flex-col items-center gap-3 text-center [--ui-container:42rem]">
        <h1 class="font-headline text-4xl md:text-6xl" v-text="product.title" />
        <div
          v-if="product.intro"
          data-intro
          class="text-2xl"
          v-html="product.intro"
        />
      </UContainer>

      <UiProductsInfoCardList :product="product" />

      <UContainer class="mt-12 lg:mt-20">
        <div class="mx-3 flex items-center gap-21 md:mx-6 lg:mx-8">
          <div
            v-if="product.description"
            class="text-lg md:text-xl lg:leading-9"
            v-html="product.description"
          />
          <CrystallizeImage
            :image="product.illustration"
            class="hidden max-w-100 lg:block"
            img-class="object-cover"
          />
        </div>
      </UContainer>
    </section>

    <section v-if="product.relatedProducts.length > 0" class="relative bg-white/50 pt-32 pb-28">
      <div class="absolute inset-x-0 -top-24 mx-auto flex w-fit flex-col items-center gap-4">
        <h2 class="font-headline text-3xl">
          Få {{ product.title }} ved å kjøpe:
        </h2>
        <IconsArrowsDownWave class="fill-(--color)" />
      </div>

      <ul class="mx-auto flex flex-wrap justify-center gap-4">
        <li v-for="related in product.relatedProducts" :key="related.id">
          <CardsProduct :product="toProductCard(related)" class="w-80" />
        </li>
      </ul>
    </section>
  </article>
</template>
